<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions" v-if="can('write_carrier_types')">
      <router-link class="btn btn-success" :to="{ name: 'carrier_type_create' }" tag="button">{{
        'routes_carrier_types_create' | t
      }}</router-link>
    </div>
    <sweet-modal ref="servicesModal">
      <div class="text-left" v-if="carrier_type">
        <template v-if="requiredLocalAttrs.length > 0">
          <div class="form-group" v-for="a in requiredLocalAttrs">
            <label class="form-label">{{ a.attr_name }}</label>
            <input class="form-control" v-model="a.attr_value" />
          </div>
          <button class="btn btn-outline-primary" @click="getCapability">Update service list</button>
        </template>
        <template v-if="carrier_type.services.length == 0">
          <div class="alert alert-info mt-3">
            No services present at current. You might have to add customer specific information to load services from
            the selected carrier
          </div>
        </template>
        <template v-if="carrier_type.services.length > 0"
          ><small>Click service to see add ons</small>
          <table class="table">
            <thead>
              <th colspan="2">Service (service code)</th>
            </thead>
            <tbody>
              <tr v-for="service in carrier_type.services">
                <td>
                  <a data-toggle="collapse" :href="'#collapse_' + service.service_code"
                    >{{ service.service_name }} ({{ service.service_code }})
                    <div class="collapse" :id="'collapse_' + service.service_code">
                      <small v-if="service.add_ons" v-for="add_on in service.add_ons"
                        >- {{ add_on.add_on_name }} ({{ add_on.add_on_code }})</small
                      >
                    </div></a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </sweet-modal>
    <lazy-table v-model="carrier_types" model="carrier_types" ref="table" :params="query">
      <table class="table table-hover table-bordered table-responsive w-100 d-block d-md-table">
        <thead>
          <tr>
            <sortable-th v-model="query.sort" sort_key="name">
              <span>{{ 'name' | t }}</span></sortable-th
            >
            <th class="text-center" v-for="c in capabilities">{{ c[1] | t }}</th>
            <th class="text-center">{{ 'colli_type_support' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="carrier_type in carrier_types" :key="carrier_type.id">
            <td>
              <strong>
                <router-link :to="{ name: 'carrier_type', params: { carrier_type_id: carrier_type.id } }">{{
                  carrier_type.name
                }}</router-link></strong
              >
              <div class="badge ml-2 badge-sm badge-primary" v-if="carrier_type.beta">Beta</div>
              <br /><strong class="text-muted">{{ carrier_type.carrier_code }}</strong>
            </td>
            <td class="text-center" v-for="c in capabilities"><i class="fa fa-check" v-if="carrier_type[c[0]]"></i></td>
            <td>{{ carrier_type.colli_type_support | t }}</td>
            <td>
              <button class="btn btn-sm btn-outline-primary" @click="openServicesModal(carrier_type)">Services</button>
            </td>
          </tr>
        </tbody>
      </table>
    </lazy-table>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';

export default {
  data: function () {
    return {
      carrier_types: [],
      carrier_type: null,
      capabilities: [
        ['supports_zpl', 'supports_zpl'],
        ['shipment_deletion_endpoint_url', 'supports_deletion'],
        ['supports_shipment_updates', 'supports_shipment_updates'],
        ['pickup_url', 'supports_pickup'],
        ['waybill_endpoint_url', 'supports_waybills'],
        ['supports_price_quoting', 'supports_price_quoting'],
        ['supports_tracking', 'supports_tracking'],
        ['supports_test_mode', 'supports_test_mode'],
        ['rate_quote_validation', 'rate_quote_validation'],
        ['supports_documents', 'supports_documents'],
        ['freightsolution_name', 'freightsolution_supported']
      ],
      query: {
        sort: 'name',
        limit: 100,
        fields: {
          carrier_types:
            'id,rate_quote_validation,name,carrier_code,supports_zpl,beta,supports_shipment_updates,shipment_deletion_endpoint_url,supports_price_quoting,supports_tracking,pickup_url,supports_documents,supports_test_mode,freightsolution_name,colli_type_support'
        }
      }
    };
  },
  mounted() {
    this.$store.commit('setBreadcrumbs', [{ to: { name: 'carrier_types' }, text: 'Carrier Types' }]);
  },
  computed: {
    requiredLocalAttrs() {
      if (!this.carrier_type) {
        return [];
      }

      return _.filter(this.carrier_type.local_attrs, 'is_required');
    }
  },
  methods: {
    customerSpecificAttributes() {
      return Object.fromEntries(this.carrier_type.local_attrs.map((a) => [a.attr_key, a.attr_value]));
    },
    async openServicesModal(carrier_type) {
      let { data } = await Api.find('carrier_types', carrier_type.id);
      this.carrier_type = data;
      for (let a of this.carrier_type.local_attrs) {
        this.$set(a, 'attr_value', null);
      }
      this.$refs.servicesModal.open();
    },
    async getCapability() {
      let { data } = await Api.create('capabilities', {
        carrier_code: this.carrier_type.carrier_code,
        customer_specific_attributes: this.customerSpecificAttributes()
      });

      this.carrier_type.services = data.services;
      return data;
    }
  },
  watch: {
    query: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      }
    }
  }
};
</script>

<style scoped></style>
